import React from "react";
import "./index.scss";
import tem1 from "../../assets/tem1.png";
import tem2 from "../../assets/tem2.png";
import tem3 from "../../assets/tem3.png";
import tem4 from "../../assets/tem4.png";
import nav from "../../assets/nav.png";
const testimonialsData = [
  {
    text: "Faire un don à cette fondation a été une décision simple pour moi. J'ai été touché par leur transparence et leur engagement envers les communautés en Afrique. Chaque euro que j'ai donné a eu un impact visible, que ce soit dans l'éducation ou l'accès à l'eau potable. Je suis fier de contribuer à un avenir meilleur.",
    image: tem1,
    name: "Jean-Luc D.",
    position: "Donateur régulier",
  },
  {
    text: "Lorsque j'ai découvert cette fondation, j'ai été impressionnée par leur passion pour changer les choses. J'ai parrainé un projet scolaire, et aujourd'hui, je reçois des nouvelles régulières sur l'évolution des enfants soutenus. Cela donne un vrai sens à mon geste.",
    image: tem2,
    name: "Scopic M.",
    position: "Donateur Régulier",
  },
  {
    text: "Ce que j'aime le plus dans cette fondation, c'est leur humanité. Ils ne se contentent pas de donner des ressources, ils construisent des opportunités durables. Donner m'a permis de faire partie de quelque chose de plus grand que moi.",
    image: tem3,
    name: "Ahmed K.",
    position: "Partenaire engagé",
  },
  {
    text: "Après mon premier don, j'ai pu voir concrètement les résultats de mes contributions grâce aux rapports détaillés et aux photos. Je suis convaincue que chaque geste compte, et cette fondation m'a donné confiance.",
    image: tem4,
    name: " Marie T.",
    position: "Donatrice occasionnelle",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <div className="container-t">
        <h2 className="title">Témoignages</h2>
        <p className="subtitle">
          Les témoignages de nos donateurs reflètent l’impact concret de leurs
          contributions pour transformer des vies en Afrique.
        </p>
        <div className="cards">
          {testimonialsData.map((testimonial, index) => (
            <div className="card" key={index}>
              <p className="text">{testimonial.text}</p>
              <div className="profile">
                <img
                  className="image"
                  src={testimonial.image}
                  alt={testimonial.name}
                />
                <div className="text_profile">
                  <h3 className="name">{testimonial.name}</h3>
                  <p className="position">{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex   mt-5 justify-content-center align-items-center">
          <img src={nav} alt="nav" />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
